export default __webpack_public_path__ + "static/media/logo-intec.48867fe8.svg";